import React, { Component } from 'react';
import { Container, Form, Row} from 'react-bootstrap';
import styled, { ThemeProvider } from 'styled-components';
import theme from '../../../../Config/Theme';

const Div = styled.div`
    background-color: white;
    color: black;
`

class Performance extends Component{

    render() {
        return (
            <ThemeProvider theme={theme}>
                <Div>
                    <Container>
                        <Form className="p-3">
                            
                            <div className="form-section">
                                <h4>Performance Management</h4>
                                <hr />
                                <p className="font-italic font-weight-bold">
                                On a scale from 1 to 5 (1-Very Unfamiliar and
                                5-Very Familiar...)
                                </p>

                                <Form.Group
                                as={Row}
                                name="formPerformanceProcess"
                                controlId="formPerformanceProcess"
                                onChange={this.props.handleChangeAsInt}
                                >
                                <Form.Label column sm={5}>
                                    14. How familiar are you with the performance review process?
                                </Form.Label>
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="1"
                                    value="1"
                                    name="formPerformanceProcess"
                                    id="formPerformanceProcess-1"
                                    defaultChecked={this.props.formPerformanceProcess === 1}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="2"
                                    value="2"
                                    name="formPerformanceProcess"
                                    id="formPerformanceProcess-2"
                                    defaultChecked={this.props.formPerformanceProcess === 2}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="3"
                                    value="3"
                                    name="formPerformanceProcess"
                                    id="formPerformanceProcess-3"
                                    defaultChecked={this.props.formPerformanceProcess === 3}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="4"
                                    value="4"
                                    name="formPerformanceProcess"
                                    id="formPerformanceProcess-4"
                                    defaultChecked={this.props.formPerformanceProcess === 4}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="5"
                                    value="5"
                                    name="formPerformanceProcess"
                                    id="formPerformanceProcess-5"
                                    defaultChecked={this.props.formPerformanceProcess === 5}
                                />
                                </Form.Group>

                                <Form.Group
                                name="formPerformanceFeedback"
                                as={Row}
                                controlId="formPerformanceFeedback"
                                onChange={this.props.handleChange}
                                >
                                    <Form.Label column sm={5}>
                                        15. Do you consistently (at least once a month) receive feedback from your manager that is geared toward improving your performance?
                                    </Form.Label>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        label="Yes"
                                        value="yes"
                                        name="formPerformanceFeedback"
                                        id="formPerformanceFeedback-Yes"
                                        defaultChecked={
                                        this.props.formPerformanceFeedback === "yes"
                                        }
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        label="No"
                                        value="no"
                                        name="formPerformanceFeedback"
                                        id="formPerformanceFeedback-No"
                                        defaultChecked={
                                        this.props.formPerformanceFeedback === "no"
                                        }                               
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        label="Unknown"
                                        value="unknown"
                                        name="formPerformanceFeedback"
                                        id="formPerformanceFeedback-NA"
                                        defaultChecked={
                                        this.props.formPerformanceFeedback === "unknown"
                                        }
                                    />
                                </Form.Group>
                                
                            </div>
                        </Form>
                    </Container>
                </Div>
            </ThemeProvider>
        )
    }
}

export default Performance;